import type { ISelectItem, IVenueVm } from '@/types';
import { defineStore } from 'pinia';

export const useVenueStore = defineStore({
    id: "useVenueStore",
    state: () => ({
        rootUrl: '/api/Participation/',
        venues: [] as Array<IVenueVm>,
        venuesSelector: [] as Array<ISelectItem>,
        allVenues: [] as Array<ISelectItem>,
        isLoadingVenues: false,
        isLoadingAllVenues: false,
        isLoadingVenueSelector: false
    }),
    actions: {
        async getVenuesByCurrentLogin() {

            if(this.isLoadingVenues || this.venues.length > 0) return;

            try {
                this.isLoadingVenues = true
                const response = await this.axiosFactory
                .withoutToken()
                .get(`${this.$state.rootUrl}GetVenuesByCurrentLogin`);

                if (response.data) {
                    this.venues = response.data.data;
                }
            } catch (error: any) {
                console.log(error, error.response)
            } finally {
                this.isLoadingVenues = false
            }
        },

        async getVenuesSelector(shouldCheckForProgramVenue: boolean = false) {

            if(this.isLoadingVenueSelector || this.venuesSelector.length > 0) return;

            try {
                this.isLoadingVenueSelector = true
                const response = await this.axiosFactory
                .withoutToken()
                .get(`${this.$state.rootUrl}GetVenuesSelector?shouldCheckForProgramVenue=${shouldCheckForProgramVenue}`);

                if (response.data) {
                    this.venuesSelector = response.data.data
                }
            } catch (error: any) {
                console.log(error, error.response)
            } finally {
                this.isLoadingVenueSelector = false
            }
        },

        async getParticipationVenues() {

            if(this.isLoadingAllVenues || this.allVenues.length > 0) return;

            try {

                this.isLoadingAllVenues = true
                const response = await this.axiosFactory
                .withoutToken()
                .get(`${this.$state.rootUrl}GetParticipationVenues`);

                if (response.data) {
                    this.allVenues = response.data.data
                }

            } catch (error: any) {
                console.log(error, error.response)
            } finally {
                this.isLoadingAllVenues = false
            }
        },
    }
})